import {
  CustomButton,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomModal,
  CustomNumberInput,
  CustomTextInput,
  Text,
  useText,
  warningDialog, // Added missing import
} from '@src/components';

import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types'; // Added PropTypes
import { useDispatch, useSelector } from 'react-redux';
import { Form, Typography, Popover } from 'antd';
import { Header } from '@src/components/CustomDialog';
import modalClose from '@src/assets/icons/icon-close.svg';
import modalWarning from '@src/assets/icons/icon-modal-warning.svg';

import { counterFormat } from '@src/utils/utils';
import { useTimer } from 'react-timer-hook';
import {
  reGmsSendOtp,
  reEmailSendOtp,
  reConfirmGmsOtp,
  reConfirmEmailOtp,
} from '@src/store/slice/userSlice';
import NewPhoneOrEmailFormModal from './NewPhoneOrEmailFormModal';

const { Text: TextStrong, Paragraph } = Typography;

const CustomMobileNumberText = ({ user, isCounterTimer }) => {
  return (
    <>
      {user?.inputName === 'mobilePhones' && isCounterTimer === null && (
        <>
          <Paragraph>
            <Text t="registeredInTheSystem" /> {user.name}{' '}
            <Text t="toUpdateYourMobilePhoneNumberPlease" />{' '}
            <TextStrong strong>
              <Text t="getCode" />
            </TextStrong>{' '}
            <Text t="clickTheButtonAndEnterTheVerificationCode2" />
          </Paragraph>
          <Paragraph>
            <Text t="ifYouDoNotHaveAccessToYour" />{' '}
            <TextStrong strong>musteri@ticket.com.tr</TextStrong>adresine{' '}
            <TextStrong strong>
              <Text t="mobilePhoneUpdateRequest" />
            </TextStrong>{' '}
            <Text t="youCanPerformYourNumberChangeProcessBy" />
          </Paragraph>
        </>
      )}

      {user?.inputName === 'mobilePhones' && isCounterTimer !== null && (
        <>
          <Paragraph>
            <Text t="toYourMobilePhoneRegisteredInTheSystem" />{' '}
            <TextStrong strong>
              <Text t="verifyCode" />
            </TextStrong>{' '}
            <Text t="hasBeenSentPleaseEnterThisCodeTo" />
          </Paragraph>
          <Paragraph>
            <Text t="ifYouDoNotHaveAccessToYour" />{' '}
            <TextStrong strong>musteri@ticket.com.tr</TextStrong>adresine{' '}
            <TextStrong strong>
              <Text t="mobilePhoneUpdateRequest" />
            </TextStrong>{' '}
            <Text t="youCanPerformYourNumberChangeProcessBy" />
          </Paragraph>
        </>
      )}
    </>
  );
};

CustomMobileNumberText.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    inputName: PropTypes.string,
  }),
  isCounterTimer: PropTypes.bool,
};

const CustomEmailText = ({ user, isCounterTimer }) => {
  return (
    <>
      {user?.inputName === 'email' && isCounterTimer === null && (
        <>
          <Paragraph>
            <Text t="registeredInTheSystem" /> {user.name}{' '}
            <Text t="toUpdateYourEMailAddressPlease" />{' '}
            <TextStrong strong>
              <Text t="getCode" />
            </TextStrong>{' '}
            <Text t="clickTheButtonAndEnterTheVerificationCode" />
          </Paragraph>
          <Paragraph>
            <Text t="ifYouDoNotHaveAccessToYour2" />{' '}
            <TextStrong strong>musteri@ticket.com.tr</TextStrong>adresine{' '}
            <TextStrong strong>
              <Text t="eMailUpdateRequest" />{' '}
            </TextStrong>{' '}
            <Text t="youCanPerformYourEMailAddressChange" />
          </Paragraph>
        </>
      )}

      {user?.inputName === 'email' && isCounterTimer !== null && (
        <>
          <Paragraph>
            <Text t="toYourEMailAddressRegisteredInThe" />{' '}
            <TextStrong strong>
              <Text t="verifyCode" />
            </TextStrong>{' '}
            <Text t="hasBeenSentPleaseEnterThisCodeTo2" />
          </Paragraph>
          <Paragraph>
            <Text t="ifYouDoNotHaveAccessToYour" />{' '}
            <TextStrong strong>musteri@ticket.com.tr</TextStrong>adresine{' '}
            <TextStrong strong>
              <Text t="eMailUpdateRequest" />
            </TextStrong>{' '}
            <Text t="youCanPerformYourEMailAddressChange" />
          </Paragraph>
        </>
      )}
    </>
  );
};

CustomEmailText.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    inputName: PropTypes.string,
  }),
  isCounterTimer: PropTypes.bool,
};

const CustomNumberInputSuffix = ({ counter, handleSendSmsAgain }) => {
  return (
    <>
      {counter.minutes === 0 && counter.seconds === 0 ? (
        <button
          type="button"
          style={{
            color: '#0d6efd',
            cursor: 'pointer',
            fontSize: '14px',
            border: 'none',
            background: 'transparent',
            padding: 0,
          }}
          className="sendAgain"
          onClick={() => handleSendSmsAgain()}
        >
          <Text t="sendVerifyCodeAgain" />
        </button>
      ) : (
        <Popover
          content={<Text t="transaction.retryVerificationCode" />}
          placement="right"
          trigger="click"
          overlayClassName="sms-tooltip"
        >
          <button
            type="button"
            style={{
              color: '#0d6efd',
              cursor: 'pointer',
              fontSize: '14px',
              border: 'none',
              background: 'transparent',
              padding: 0,
            }}
            className="sendAgain"
            onClick={() => handleSendSmsAgain()}
          >
            <Text t="sendVerifyCodeAgain" />
          </button>
        </Popover>
      )}
    </>
  );
};

CustomNumberInputSuffix.propTypes = {
  counter: PropTypes.shape({
    minutes: PropTypes.number,
    seconds: PropTypes.number,
  }),
  handleSendSmsAgain: PropTypes.func,
};

const EditPhoneOrEmailFormModal = ({ modalVisible, handleModalVisible, user, currentUser }) => {
  const [isCounterTimer, setIsCounterTimer] = useState(null);
  const [newPhoneOrEmailFormModalVisible, setNewPhoneOrEmailFormModalVisible] = useState(false);
  const { resGmsSendOtp, resEmailSendOtp } = useSelector((state) => state?.user);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const time = new Date();
  const deadline = time.setMinutes(time.getMinutes() + 2);
  const counter = useTimer({ autoStart: false, expiryTimestamp: deadline });

  // 1. Hook extraction to the top-level
  const namePlaceholder = useText('name');
  const enterDigitVerifCodePlaceholder = useText('enterDigitVerifCode');
  const headerTitle = `${useText('personalInfo')} - ${useText('edit')}`;

  useEffect(() => {
    if (user?.name) {
      form.setFieldsValue({
        name: user?.name,
      });
    }
  }, [user, form]);

  const getLabelName = () => (user?.inputName === 'mobilePhones' ? 'phoneNumber' : 'emailAdress');

  const handleClose = useCallback(() => {
    form.resetFields();
    counter.pause();
    setIsCounterTimer(null);
    handleModalVisible(false);
  }, [handleModalVisible, form, counter]);

  const onFinishEdit = useCallback(
    async (values) => {
      if (values?.otp.toString().length === 6) {
        const data = {
          mobileId:
            user?.inputName === 'mobilePhones' ? resGmsSendOtp?.guidKey : resEmailSendOtp?.guidKey,
          otp: parseFloat(values?.otp),
        };

        if (user?.inputName === 'mobilePhones') {
          const action = await dispatch(reConfirmGmsOtp(data));
          if (reConfirmGmsOtp.fulfilled.match(action)) {
            handleClose();
            setNewPhoneOrEmailFormModalVisible(true);
          }
        } else {
          const action = await dispatch(reConfirmEmailOtp(data));
          if (reConfirmEmailOtp.fulfilled.match(action)) {
            handleClose();
            setNewPhoneOrEmailFormModalVisible(true);
          }
        }
      } else {
        warningDialog({
          title: <Text t="warning" />,
          htmlContent: <Text t="mustBe6Char" />,
        });
      }
    },
    [
      handleClose,
      dispatch,
      user,
      resGmsSendOtp,
      resEmailSendOtp,
    ],
  );

  const reGmsSendOtpFn = useCallback(async () => {
    const data = { gsm: user?.name };
    const action = await dispatch(reGmsSendOtp(data));

    if (reGmsSendOtp.fulfilled.match(action)) {
      counter.restart(new Date().setMinutes(new Date().getMinutes() + 2));
    } else {
      counter.pause();
    }
  }, [counter, dispatch, user]);

  const reEmailSendOtpFn = useCallback(async () => {
    const data = { gsm: user?.name };
    const action = await dispatch(reEmailSendOtp(data));

    if (reEmailSendOtp.fulfilled.match(action)) {
      counter.restart(new Date().setMinutes(new Date().getMinutes() + 2));
    } else {
      counter.pause();
    }
  }, [counter, dispatch, user]);

  const handleSendSmsAgain = useCallback(async () => {
    if (isCounterTimer === null) {
      setIsCounterTimer(true);
      if (user?.inputName === 'mobilePhones') {
        reGmsSendOtpFn();
      } else {
        reEmailSendOtpFn();
      }
    } else if (counter.minutes === 0 && counter.seconds === 0) {
      if (user?.inputName === 'mobilePhones') {
        reGmsSendOtpFn();
      } else {
        reEmailSendOtpFn();
      }
    }
  }, [counter, isCounterTimer, user, reGmsSendOtpFn, reEmailSendOtpFn]);

  return (
    <>
      <CustomModal
        className="profile-user-phone-or-email-model"
        maskClosable={false}
        footer={false}
        title={
          <Header
            title={headerTitle}
            type={'warning'}
            icon={modalWarning}
          ></Header>
        }
        visible={modalVisible}
        onCancel={handleClose}
        closeIcon={<CustomImage src={modalClose} />}
      >
        <CustomMobileNumberText user={user} isCounterTimer={isCounterTimer} />
        <CustomEmailText user={user} isCounterTimer={isCounterTimer} />

        <CustomForm
          name="personalInformation"
          onFinish={onFinishEdit}
          form={form}
          initialValues={{
            name: user?.name,
          }}
          awaitLoading={!user?.id}
          autoComplete="off"
          layout={'vertical'}
        >
          <div className="row ">
            <div className="col-md-12">
              <CustomFormItem label={<Text t={getLabelName()} />} name="name">
                <CustomTextInput
                  id="myProfile-personalInformation-name-textInput"
                  data-testid="name"
                  placeholder={namePlaceholder} // 2. Used variable here
                  disabled
                />
              </CustomFormItem>
            </div>

            <div className="col-md-12">
              <CustomFormItem
                name="otp"
                label={<Text t={'verifyCode'} />}
                rules={[
                  { required: true, message: <Text t="checkSMSProfile" /> },
                  { type: 'number', min: 100000, message: <Text t="mustBe6Char" /> },
                ]}
              >
                <CustomNumberInput
                  id="smsVerification-main-otp-numberInput"
                  autoComplete="off"
                  placeholder={enterDigitVerifCodePlaceholder} // 2. Used variable here
                  maxLength={6}
                  suffix={
                    isCounterTimer === null ? (
                      <button
                        type="button"
                        style={{
                          color: '#0d6efd',
                          cursor: 'pointer',
                          fontSize: '14px',
                          border: 'none',
                          background: 'transparent',
                          padding: 0,
                        }}
                        onClick={() => handleSendSmsAgain()}
                      >
                        <Text t="getCode" />
                      </button>
                    ) : (
                      <CustomNumberInputSuffix
                        counter={counter}
                        handleSendSmsAgain={handleSendSmsAgain}
                      />
                    )
                  }
                />
              </CustomFormItem>
            </div>
          </div>

          <label className="labelRemainingTime" style={{ paddingBottom: '10px' }}>
            {isCounterTimer && (
              <span style={{ color: '#646363', fontSize: '11px' }}>
                <Text t="remainingTime" />{' '}
                <span
                  style={
                    counter.minutes === 0 && counter.seconds === 0
                      ? { color: '#f72717' }
                      : { color: '#00a483' }
                  }
                >
                  {counterFormat(counter)}
                </span>
              </span>
            )}
          </label>

          <CustomFormItem className="custom-form-footer">
            <CustomButton
              id="myProfile-personalInformation-custom-btn-cancel"
              data-testid="cancel"
              className="custom-btn-cancel"
              onClick={handleClose}
            >
              <span className="submit">
                <Text t="giveUp" />
              </span>
            </CustomButton>
            <CustomButton
              id="myProfile-personalInformation-custom-btn-primary"
              data-testid="submit"
              className="custom-btn-primary"
              type="primary"
              htmlType="submit"
            >
              <span className="submit">
                <Text t="continue" />
              </span>
            </CustomButton>
          </CustomFormItem>
        </CustomForm>
      </CustomModal>
      <NewPhoneOrEmailFormModal
        modalVisible={newPhoneOrEmailFormModalVisible}
        handleModalVisible={setNewPhoneOrEmailFormModalVisible}
        user={user}
        currentUser={currentUser}
      />
    </>
  );
};

EditPhoneOrEmailFormModal.propTypes = {
  modalVisible: PropTypes.bool,
  handleModalVisible: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    inputName: PropTypes.string,
  }),
  currentUser: PropTypes.object,
};

export default EditPhoneOrEmailFormModal;